import { ApiResponse } from "@src/types/httpApi";
import { ITag } from "@src/types/tags";
import httpApi from "@src/utils/httpApi";
import { AxiosResponse } from "axios";

export const fetchTagsApi = async ({
  searchText,
  page = 1,
  pageSize = 50,
}: {
  searchText?: string;
  page?: number;
  pageSize?: number;
}): Promise<AxiosResponse<ApiResponse<ITag[]>>> => {
  const queryParams = new URLSearchParams();
  if (searchText) {
    queryParams.append(
      "filters[title][$containsi]",
      String(searchText).toLowerCase().trim()
    );
  }
  queryParams.append("pagination[page]", String(page));
  queryParams.append("pagination[pageSize]", String(pageSize));
  return httpApi.get(`/api/tags?${queryParams.toString()}`);
};

export const createTagApi = async ({ title }: { title: string }) => {
  return httpApi.post(`/api/tags`, { data: { title } });
};

// Genres tags
export const fetchGenresTags = async ({
  searchText,
  page = 1,
  pageSize = 50,
}: {
  searchText?: string;
  page?: number;
  pageSize?: number;
}): Promise<AxiosResponse<ApiResponse<ITag[]>>> => {
  const queryParams = new URLSearchParams();
  if (searchText) {
    queryParams.append(
      "filters[title][$containsi]",
      String(searchText).toLowerCase().trim()
    );
  }
  queryParams.append("pagination[page]", String(page));
  queryParams.append("pagination[pageSize]", String(pageSize));
  queryParams.append("populate[subGenres][fields]", "*");
  return httpApi.get(`/api/genres?${queryParams.toString()}`);
};

export const createGenresTagApi = async ({ title }: { title: string }) => {
  return httpApi.post(`/api/genres`, { data: { title } });
};

export const updateGenresTagApi = async ({
  tagId,
  title,
}: {
  tagId: string;
  title: string;
}) => {
  return httpApi.put(`/api/genres/${tagId}`, { data: { title } });
};

export const deleteGenresTagApi = async ({ tagId }: { tagId: string }) => {
  return httpApi.delete(`/api/genres/${tagId}`);
};

// Feeling tags / Emotions
export const fetchFeelingTags = async ({
  searchText,
  page = 1,
  pageSize = 50,
}: {
  searchText?: string;
  page?: number;
  pageSize?: number;
}): Promise<AxiosResponse<ApiResponse<ITag[]>>> => {
  const queryParams = new URLSearchParams();
  if (searchText) {
    queryParams.append(
      "filters[title][$containsi]",
      String(searchText).toLowerCase().trim()
    );
  }
  queryParams.append("pagination[page]", String(page));
  queryParams.append("pagination[pageSize]", String(pageSize));
  return httpApi.get(`/api/emotions?${queryParams.toString()}`);
};

export const createFeelingTagApi = async ({ title }: { title: string }) => {
  return httpApi.post(`/api/emotions`, { data: { title } });
};

export const updateFeelingsTagApi = async ({
  title,
  tagId,
}: {
  title: string;
  tagId: string;
}) => {
  return httpApi.put(`/api/emotions/${tagId}`, { data: { title } });
};

export const deleteFeelingTagApi = async ({ tagId }: { tagId: string }) => {
  return httpApi.delete(`/api/emotions/${tagId}`);
};
